import { render } from "./JobInfo.vue?vue&type=template&id=e62b8120&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import "./JobInfo.vue?vue&type=style&index=0&id=e62b8120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e62b8120"]])

export default __exports__